import React from 'react';
import { membershipData } from '../mockData';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

const Membership = () => {
  const handleNotifyMe = () => {
    // Scroll to join form to sign up as a member
    const ctaSection = document.getElementById('cta-join');
    ctaSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="membership" className="membership-section">
      <div className="membership-container">
        {/* Section Header */}
        <div className="section-header">
          <Badge className="coming-soon-badge">
            <Star size={14} />
            {membershipData.subtitle}
          </Badge>
          <h2 className="section-title">{membershipData.title}</h2>
          <p className="section-description">{membershipData.description}</p>
        </div>

        {/* Membership Plans */}
        <div className="membership-grid">
          {membershipData.plans.map((plan) => (
            <div 
              key={plan.id} 
              className={`membership-card ${plan.featured ? 'featured-plan' : ''}`}
            >
              {plan.featured && (
                <div className="featured-badge">
                  <Star size={16} />
                  Most Popular
                </div>
              )}
              
              <div className="plan-header">
                <h3 className="plan-name">{plan.name}</h3>
                <div className="plan-status">{plan.status}</div>
              </div>

              <ul className="plan-features">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="plan-feature">
                    <Check size={20} className="feature-check" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <Button 
                className={`plan-button ${plan.featured ? 'featured-button' : ''}`}
                onClick={handleNotifyMe}
                data-testid={`notify-me-${plan.id}`}
              >
                Notify Me
              </Button>
            </div>
          ))}
        </div>

        {/* Info Note */}
        <div className="membership-note">
          <p>Want early access? Join our community to be the first to know when memberships launch!</p>
        </div>
      </div>
    </section>
  );
};

export default Membership;
